export class ExternalUrlPage {
  index: number = -1;
  id: string = '';
  available: boolean = true;
  label: string = '';
  url: string = '';
  machineTab: boolean = false;

  constructor(id: string, label: string, isMachineTab: boolean, url: string) {
    this.id = id;
    this.label = label;
    this.machineTab = isMachineTab;
    this.url = url;
  }
}